import classNames from 'classnames'

export const MyIcon: React.FC<{
  icon: string
  className?: string
  style?: React.CSSProperties
  onClick?: () => void
}> = ({ icon, className, ...rest }) => {
  return (
    <i
      {...rest}
      className={classNames(
        'trade-icon',
        `trade-icon-${icon}`,
        `leading-none`,
        className
      )}
    ></i>
  )
}
